export default function ExpandItemIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none" {...props}>
            <path d="M9.02588 4.85156L5 0.825684L0.974121 4.85156" stroke="#095546" strokeWidth="1.34196" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
